import { Project, UserLocationShare } from "@nova/protobuf"
import {
    booleanValidator,
    createLayerValidator,
    nameValidators,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"

export const createUserLocationShareValidator = createLayerValidator(UserLocationShare, {
    name: { validators: nameValidators, nonNull: true },
    index: { validators: [], nonNull: true },
    parentId: { validators: [] },
})

export const updateUserLocationShareValidator = updateLayerValidator(UserLocationShare, {
    live: { validators: booleanValidator("live"), nonNull: true },
    endedAt: { validators: [] },
})

export const getDefaultUserLocationShareCreateArgs = (project: Project, inParentId?: string) => {
    const parentId = !inParentId || inParentId === "null" ? undefined : inParentId
    return {
        visible: true,
        createdAt: dateAsNumber(),
        index: createNewLayerFractionalIndex(project, 0, parentId),
        parentId,
        live: false,
    }
}

export type CreateUserLocationShareArgs = UnionToTuple<
    keyof typeof createUserLocationShareValidator
>
export type UpdateUserLocationShareArgs = UnionToTuple<
    keyof typeof updateUserLocationShareValidator
>
